import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const GhIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    {...props}
  >
    <path fill="#006b3f" d="M0 0h640v480H0z" />
    <path fill="#fcd116" d="M0 0h640v320H0z" />
    <path fill="#ce1126" d="M0 0h640v160H0z" />
    <path fill="#000001" d="m320 160 52 160-136.1-98.9H404L268 320z" />
  </ChakraIcon>
);
